import React from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';

import Button from 'components/Button';
import Modal, { ModalHeader, ModalFooter } from 'components/Modal';

import './style.scss';

const DeleteModal = ({ onCloseRequest, onDelete }) => (
  <Modal isOpen closeOnEsc onCloseRequest={onCloseRequest}>
    <ModalHeader
      icon={<span className="icon-warning" styleName="icon-warning" />}
      title={
        <span styleName="title">
          <span>You will delete all files. Are you really sure?</span>
        </span>
      }
    />

    <ModalFooter justifyContent="flex-end">
      <Button
        isLarge
        isTransparent
        type="button"
        data-test="cancel-button"
        onClick={onCloseRequest}
      >
        Cancel
      </Button>

      <Button
        isLarge
        isWarning
        type="button"
        onClick={onDelete}
        data-test="submit-button"
      >
        Yes delete them
      </Button>
    </ModalFooter>
  </Modal>
);

DeleteModal.propTypes = {
  onCloseRequest: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
};

DeleteModal.defaultProps = {
  onCloseRequest: noop,
};

export default DeleteModal;
